// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

const getState = state => state.hive2Upgrade || fromJS({});

export const getIsUpgrading = createSelector(getState, state => state.get('hive2IsUpgrading'));

export const getUpgradeStartTime = createSelector(getState, state => state.get('hive2UpgradeStartTime'));

export const getHive2IsUpgrading = createSelector(getState, state => state.get('hive2IsUpgrading'));

export const getHive2UpgradeFinished = createSelector(getState, state => state.get('hive2UpgradeFinished'));

export const getHive2UpgradeRouteState = createSelector(getState, state => state.get('hive2UpgradeRouteState'));



// WEBPACK FOOTER //
// ./src/core/state/install-upgrade-thermostat/hive2/selectors.js